import React, { Fragment } from 'react';
import { Alert } from 'antd';

export default function ResubscribeSuccess() {
  return (
    <Fragment>
      <Alert
        className="re-subscription"
        message="Re-subscription successful!"
        showIcon
        type="success"
      />
      <br />
      <div>
        <h2>You have successfully re-subscribed!</h2>
        <p>
          Your re-subscription to emails from Turing was successful. You will
          continue to receive emails from Turing!
        </p>
      </div>
    </Fragment>
  );
}
